var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversionRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0625 42.1875C89.0625 39.6094 86.9531 37.5 84.375 37.5H12.5C9.92188 37.5 7.8125 39.6094 7.8125 42.1875V46.8907H89.0625V42.1875ZM32.8125 33.3282C32.8125 30.7032 33.4844 28.0938 34.7656 25.7969C36.1234 24.1969 34.6359 23.6829 31.9844 22.0938C33.0503 21.2672 33.9138 20.2087 34.5094 18.9985C35.1051 17.7883 35.4171 16.4582 35.4219 15.1094C35.0047 3.39067 18.1219 3.38286 17.7031 15.1094C17.7031 17.9375 19.0625 20.4688 21.1406 22.0938C16.9531 24.1094 14.0625 28.3907 14.0625 33.3282V34.375H32.8125V33.3282ZM60.9375 33.3282C60.9325 30.9797 60.2659 28.6801 59.014 26.6931C57.7621 24.7061 55.9756 23.1121 53.8594 22.0938C54.9253 21.2672 55.7888 20.2087 56.3844 18.9985C56.9801 17.7883 57.2921 16.4582 57.2969 15.1094C56.8797 3.39067 39.9969 3.38286 39.5781 15.1094C39.5781 17.9375 40.9375 20.4688 43.0156 22.0938C40.8994 23.1121 39.1129 24.7061 37.861 26.6931C36.6092 28.6801 35.9425 30.9797 35.9375 33.3282V34.375H60.9375V33.3282ZM62.125 25.8125C63.5859 28.3954 64.1766 31.4094 64.0625 34.375H82.8125C83.1562 29.1344 80.2781 24.2266 75.7344 22.0938C82.3375 17.0563 78.7078 6.22349 70.3125 6.25005C61.9156 6.22817 58.2859 17.05 64.8906 22.0938C63.5781 22.7188 62.3906 23.5782 61.3906 24.6094C61.6562 25 61.9062 25.4063 62.125 25.8125ZM80.1719 56.6719C70.2109 54.0735 60.0563 62.786 60.9688 72.9063C62.9875 92.8485 91.4531 91.9735 92.1875 71.875C92.1875 64.5 87.0469 58.3125 80.1719 56.6719ZM75.7031 70.3125H77.4219C82.4406 70.4094 83.0219 77.5782 78.125 78.5001C78.4187 81.0391 74.7922 81.136 75 78.5782H73.1406C71.0875 78.5376 71.0875 75.4829 73.1406 75.4532H77.4219C78.7188 75.4438 78.7359 73.4485 77.4219 73.4375H75.7031C70.6844 73.3391 70.1031 66.1719 75 65.25C74.7063 62.711 78.3328 62.6141 78.125 65.1719H79.9844C82.0375 65.2125 82.0375 68.2657 79.9844 68.2969H75.7031C74.4062 68.3047 74.3891 70.3 75.7031 70.3125Z",
    fill: "url(#paint0_linear_4_32456)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6562 53.1406C78.1687 53.0359 80.6875 53.3984 83 54.2813L87.4062 50.5625C87.6094 50.3906 87.7812 50.2188 87.9531 50.0156H8.9375C9.09375 50.2188 9.26563 50.3906 9.46875 50.5625L40.625 76.8906V92.1875C40.5828 93.3875 42.0703 94.1938 43.0469 93.4844L55.5469 85.1563C55.9844 84.875 56.25 84.375 56.25 83.8594V76.8906L58.125 75.3125C55.9109 64.4422 64.5734 53.4781 75.6562 53.1406Z",
    fill: "url(#paint1_linear_4_32456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_32456",
    x1: 7.8125,
    y1: 7.71338,
    x2: 106.129,
    y2: 103.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_32456",
    x1: 8.9375,
    y1: 50.8041,
    x2: 55.399,
    y2: 129.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversionRate);
export default __webpack_public_path__ + "static/media/Conversion-Rate.52e55c9f4d2729fa238a485ac83b31de.svg";
export { ForwardRef as ReactComponent };